import { createReducer, on } from '@ngrx/store';
import * as NearbyActions from './nearby.action';
import { DiscountData, NearbyState } from './nearby.state';

const initialDiscountData: DiscountData = {
  id: null,
  title: '',
  description: '',
  banner_image: '',
  DiscountLists: [],
};

export const initialState: NearbyState = {
  discountData: initialDiscountData,
  loading: false,
  error: null,
};

export const nearbyReducer = createReducer(
  initialState,

  // When loading discount
  on(NearbyActions.loadDiscount, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  // On successful discount load
  on(NearbyActions.loadDiscountSuccess, (state, { discountData }) => ({
    ...state,
    discountData,
    loading: false,
    error: null,
  })),

  // On failed discount load
  on(NearbyActions.loadDiscountFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

